import React from 'react';
import Link from '../../../elements/Link';
import Icon from './network-icon.svg';

function StartNetworkingIcon(props) {
    const {width, height, href = './start-networking', onClick} = props;

    return (
        <Link href={href} onClick={onClick}>
            <Icon width={width} height={height} />
        </Link>
    );
}

export default StartNetworkingIcon;
